import { utils as reducerUtils } from 'redux-rest-reducer';
import { ACTIONS } from 'actions/student-payment-link';
import RestReducer from './reducer';

export default RestReducer(ACTIONS, (state, { type }) => {
  switch (type) {
    case ACTIONS.INVALIDATE_LIST:
      return reducerUtils.changeListToStale(state);
    default:
      return state;
  }
});
